import NewPaymentMethod from './new-payment-method.vue'
export type { NewPaymentMethodProps } from './props'
export default NewPaymentMethod